import React from 'react';
import PropTypes from 'prop-types';
import { FlatList, View } from 'react-native';
import { Icon as RNVIcon } from 'renative';
import { noop } from 'Utils';
import { ActionListItem } from '../ActionListItem';

import baseStyles from './ActionList.jss';

const ActionList = ({ data, onItemPress }) => (
    <View style={baseStyles.container}>
        <FlatList
            data={data}
            renderItem={({ item }) => (
                <ActionListItem key={item.key} {...item} onPress={() => onItemPress(item)} />
            )}
            keyExtractor={(item) => item.name}
        />
        <RNVIcon
            iconFont="fontAwesome"
            iconName="caret-up"
            iconColor="#FFFFFF"
            style={baseStyles.arrowIcon}
        />
    </View>
);

ActionList.defaultProps = {
    onItemPress: noop
};

ActionList.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            iconName: PropTypes.string
        })
    ).isRequired,
    onItemPress: PropTypes.func
};

export { ActionList };
